import { SVGProps } from 'react'

const ProcessFailedIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='65' height='15' viewBox='0 0 65 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <rect width='65' height='15' rx='7.5' fill='#1E1E1E' fillOpacity='0.4' />
            <rect
                x='0.516796'
                y='0.516796'
                width='63.9664'
                height='13.9664'
                rx='6.9832'
                stroke='#E84142'
                strokeOpacity='0.1'
                strokeWidth='1.03359'
                strokeDasharray='2.07 2.07'
            />
            <circle cx='17' cy='8' r='1' fill='#E84142' />
            <circle cx='25' cy='8' r='1' fill='#E84142' />
            <circle cx='33' cy='8' r='1' fill='#E84142' />
            <circle cx='41' cy='8' r='1' fill='#E84142' />
            <circle cx='49' cy='8' r='1' fill='#E84142' />
        </svg>
    )
}
export default ProcessFailedIcon
